@if(isNonDocumentSummary){
    <div class="chat-container" [ngClass]="{'justify-end': groupedMessages?.length , 'justify-center': !groupedMessages?.length}">

        @if(groupedMessages?.length || loading){

            <div class="chat-content w-full">
        
                <div class="chat-messages" #chatMessages>
                    <div class="spacer"></div>
        
                    @for (group of groupedMessages; track group.label) {
                    <div class="timestamp-box">
                        {{ group.label }}
                    </div>
        
                    @for (message of group.messages; track message.timestamp) {
                    <div class="chat-message"
                        [ngClass]="{'user-message': message.sender === 'USER', 'system-message': message.sender === 'SYSTEM' || message.sender === 'LLM' || message.sender === 'QUESTION' || message.sender === 'TEMPLATE_QUESTION'}">
                        @if (message.sender === 'SYSTEM' || message.sender === 'LLM' || message.sender === 'QUESTION' ||
                        message.sender === 'TEMPLATE_QUESTION') {
                        <div class="message-avatar system-avatar">
                            <img src="assets/images/new-chat-icon.png" alt="Kinnect" class="kinnect-avatar">
                        </div>
                        }
                        <div class="message-content">
                            <span [innerHTML]="message.content"></span>
                        </div>
                        @if (message.sender === 'USER') {
                        <div class="message-avatar system-avatar">
                            <ngx-avatars size="32" src="{{ currentUser?.profile_image_url }}"
                                name="{{ currentUser?.first_name + ' ' + currentUser?.last_name | titlecase }}" initialsSize="2"
                                cornerRadius="50" [round]="false" class="kinnect-avatar"></ngx-avatars>
                            <!-- <img src="assets/images/chat-icon.svg" alt="Kinnect" class="kinnect-avatar"> -->
                        </div>
                        }
                    </div>
                    @if((message.state !== 'Completed') && (message?.primaryCTA || message?.secondaryCTA)) {
                    <div class="flex justify-start ml-[68px]">
                        @if(message.primaryCTA) {
                        <div class="start-intro-button cursor-pointer">
                            <div class="flex items-center justify-center">
                                {{message.primaryCTA}}
                                <mat-icon class="ml-[8px]">east</mat-icon>
                            </div>
                        </div>
                        }
                        @if(message.secondaryCTA) {
                        <div class="skip-intro-button ml-[8px] cursor-pointer">
                            <span class="skip-intro-button-text">{{ message.secondaryCTA }}</span>
                        </div>
                        }
                    </div>
                    }
                    @if(message.state === 'Completed'){
                    <div class="flex justify-start ml-[68px]">
                        <div
                            class="bg-[#EDEDED] h-[42px] px-[24px] py-[8px] w-fit flex items-center justify-center rounded-[4px] gap-[8px]">
                            <div class="h-[24px] w-[24px]"><mat-icon class="text-[#1AA140] h-[24px] w-[24px] ">check</mat-icon>
                            </div>
                            <div class="text-[#1AA140] text-base font-semibold">Completed</div>
                        </div>
                    </div>
                    }
                    }}
                   
                    @if(loading){
                    <div class="typing-indicator message-content flex items-center gap-[8px]">
                        <div class="message-avatar system-avatar">
                            <img src="assets/images/new-chat-icon.png" alt="Kinnect" class="kinnect-avatar" />
                        </div>
                        <div>
                            <div class="text-[#707070] text-sm font-open-sans font-medium">One moment while we process your request...</div>
                            <div class="dots">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                    }
        
                </div>
        
            </div>
        }
    
        <div class="w-full h-fit">
            <div class="chat-input">
                <div>
                    <textarea [(ngModel)]="messageText" 
                        [placeholder]="!groupedMessages ? 'Ask me anything about the documents linked to this template' :'Ask me anything about ' + currentTemplate.type" 
                        (input)="adjustHeight($event);"
                        class="chat-message-input" (keyup.enter)="sendMessage()">
                    </textarea>
                </div>
                <div class="flex items-center justify-between w-full mt-[10px]">
                    <div>
                    </div>
                    <div>
                        <button class="p-0 rounded-lg" [disabled]="!showSendHoverIcon" (click)="sendMessage()">
                            @if(showSendHoverIcon) {
                            <img src="assets/images/chat-input-send-hover-icon.svg" alt="Kinnect">
                            }@else{
                            <img src="assets/images/chat-input-send-icon.svg" alt="Kinnect">
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
}@else {
    <div class="chat-container" [ngClass]="{'justify-end': groupedMessages?.length , 'justify-center': !groupedMessages?.length}">

        @if(groupedMessages?.length || loading){
            <div class="chat-content w-full">
        
                <div class="chat-messages" #chatMessages>
                    <div class="spacer"></div>
        
                    @for (group of groupedMessages; track group.label) {
                    <div class="timestamp-box">
                        {{ group.label }}
                    </div>
        
                    @for (message of group.messages; track message.timestamp) {
                    <div class="chat-message"
                        [ngClass]="{'user-message': message.sender === 'USER', 'system-message': message.sender === 'SYSTEM' || message.sender === 'LLM' || message.sender === 'QUESTION' || message.sender === 'TEMPLATE_QUESTION'}">
                        @if (message.sender === 'SYSTEM' || message.sender === 'LLM' || message.sender === 'QUESTION' ||
                        message.sender === 'TEMPLATE_QUESTION') {
                        <div class="message-avatar system-avatar">
                            <img src="assets/images/new-chat-icon.png" alt="Kinnect" class="kinnect-avatar">
                        </div>
                        }
                        <div class="message-content">
                            <span [innerHTML]="message.content"></span>
                        </div>
                        @if (message.sender === 'USER') {
                        <div class="message-avatar system-avatar">
                            <ngx-avatars size="32" src="{{ currentUser?.profile_image_url }}"
                                name="{{ currentUser?.first_name + ' ' + currentUser?.last_name | titlecase }}" initialsSize="2"
                                cornerRadius="50" [round]="false" class="kinnect-avatar"></ngx-avatars>
                            <!-- <img src="assets/images/chat-icon.svg" alt="Kinnect" class="kinnect-avatar"> -->
                        </div>
                        }
                    </div>
                    @if((message.state !== 'Completed') && (message?.primaryCTA || message?.secondaryCTA)) {
                    <div class="flex justify-start ml-[68px]">
                        @if(message.primaryCTA) {
                        <div class="start-intro-button cursor-pointer">
                            <div class="flex items-center justify-center">
                                {{message.primaryCTA}}
                                <mat-icon class="ml-[8px]">east</mat-icon>
                            </div>
                        </div>
                        }
                        @if(message.secondaryCTA) {
                        <div class="skip-intro-button ml-[8px] cursor-pointer">
                            <span class="skip-intro-button-text">{{ message.secondaryCTA }}</span>
                        </div>
                        }
                    </div>
                    }
                    @if(message.state === 'Completed'){
                    <div class="flex justify-start ml-[68px]">
                        <div
                            class="bg-[#EDEDED] h-[42px] px-[24px] py-[8px] w-fit flex items-center justify-center rounded-[4px] gap-[8px]">
                            <div class="h-[24px] w-[24px]"><mat-icon class="text-[#1AA140] h-[24px] w-[24px] ">check</mat-icon>
                            </div>
                            <div class="text-[#1AA140] text-base font-semibold">Completed</div>
                        </div>
                    </div>
                    }
                    }}
                    @if(isShowTeachMe && currentTemplate){
                        <div class="w-full" (click)="showTeachMe()">
                            <div class="default-button w-fit ml-[42px]">
                                <div class="default-button-text">Teach me about {{currentTemplate.type}}</div>
                            </div>
                        </div>
                    }
        
                    @if(loading){
                    <div class="typing-indicator message-content flex items-center gap-[8px]">
                        <div class="message-avatar system-avatar">
                            <img src="assets/images/new-chat-icon.png" alt="Kinnect" class="kinnect-avatar" />
                        </div>
                        <div>
                            <div class="text-[#707070] text-sm font-open-sans font-medium">One moment while we process your request...</div>
                            <div class="dots">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                    }
        
                </div>
        
            </div>
        }
    
        <div class="w-full h-fit">
            <div class="chat-input">
                <div>
                    <textarea [(ngModel)]="messageText" placeholder="Ask me anything about this document" (input)="adjustHeight($event);"
                        class="chat-message-input" (keyup.enter)="sendMessage()"></textarea>
                </div>
                <div class="flex items-center justify-between w-full mt-[10px]">
                    <div>
                    </div>
                    <div>
                        <button class="p-0 rounded-lg" [disabled]="!showSendHoverIcon" (click)="sendMessage()">
                            @if(showSendHoverIcon) {
                            <img src="assets/images/chat-input-send-hover-icon.svg" alt="Kinnect">
                            }@else{
                            <img src="assets/images/chat-input-send-icon.svg" alt="Kinnect">
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
}